<template>
    <div class=" section_sectionWrapper">
        <div class="module-sys">
            <div class="title"></div>
            <div class="sys-cont">
                <swiper :options="sysOptions" ref="sysOptions" class="sys-silder-bg">
                    <swiper-slide v-for="i in 4" :key="i">
                        <img :src="require('../../assets/img/sys/sys-0' + i + '.png')" alt="" srcset="">
                    </swiper-slide>
                </swiper>
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'app',
    data() {
        return {

            sysOptions: {
                autoplay: true,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                allowTouchMove: false,
                loop: true,
                grabCursor: true,
                centeredSlides: true,
                slidesPerView: 'auto',
                observer: true, //修改swiper自己或子元素时，自动初始化swiper
                observeParents: true, //修改swiper的父元素时，自动初始化swiper
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },

            },
        }
    },
    watch: {

    },
    methods: {

    }
}
</script>
<style lang="scss" scoped>
.module-sys {
    position: relative;
    height: 100%;
    width: 100%;

    .title {
    
        width: 322px;
        height: 105px;
        background-size: 100% 100%;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        background-image: url("../../assets/img/sys/title.png");
    }

    .sys-cont {
        width: 950px;
        height: 675px;
        position: absolute;
        left: 50%;
        transform: translate(-50%, -50%);
        top: 55%;

        .swiper-slide {
            height: 100%;
            overflow: hidden;
        }

        .sys-silder-bg {
            position: relative;
            height: 100%;
            width: 100%;

            img {
                height: 100%;
                width: 100%;
                display: block;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                position: absolute;
            }



        }

    }

    .swiper-button-prev:after {
        display: none;
    }

    .swiper-button-next:after {
        display: none;
    }

    .swiper-button-prev {
        background: url("../../assets/img/sys/lf.png") no-repeat top;
        background-size: 100% 100%;
        width: 30px;
        height: 35px;
        top: 35%;
        left: -60px;
    }

    .swiper-button-next {
        background: url("../../assets/img/sys/lr.png") no-repeat top;
        background-size: 100% 100%;
        width: 30px;
        height: 35px;
        top: 35%;
        right: -60px;

    }
}

@media screen and (max-width: 1200px) {
    .module-sys {
        .sys-cont {
            top: 45% !important;
        }
    }
}

@media screen and (min-width: 2560px) and (max-width: 3440px) {
    .module-sys {
        .sys-cont {
            width:760px !important;
        height: 540px !important;
        top: 55% !important;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/publicComponents/sys.vue